import { render, staticRenderFns } from "./DashboardHelp.vue?vue&type=template&id=fabe8262&scoped=true&lang=html&"
import script from "./DashboardHelp.vue?vue&type=script&lang=js&"
export * from "./DashboardHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe8262",
  null
  
)

export default component.exports